// @flow
import * as React from 'react';
import {
    Box, Text, Accordion,
} from 'grommet';
import { FormattedMessage } from 'react-intl';
import CableList from 'esm-web-pro/components/pages/network/CableList';
import type { Pipe } from 'esm-web-pro/containers/pages/network/objects/pipe/Pipe';
import styled from 'styled-components';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import ContentLabel from 'esm-web-pro/components/layout/sidePanel/ContentLabel';
import AccordionPanel from 'esm-web-pro/components/layout/sidePanel/AccordionPanel';
import PermitDocumentList from 'esm-web-pro/components/pages/network/PermitDocumentList';
import { ObjectContext } from 'esm-web-pro/containers/map/MapObject';
import { isEmpty } from 'lodash';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';

type Props = {
    pipe: Pipe,
    editor: BaseEditor,
    clicked: string,
    setClicked: Function,
    map: { is_draft: boolean, uuid: string },
}

const StyledBox = styled(Box)`
    &:hover {
        cursor: pointer;
    }
`;

const PipeContent = (props: Props) => {
    const {
        pipe, editor, clicked, setClicked, map,
    } = props;
    const { cables, permit_documents: permitDocuments } = pipe;
    const [activeIndices, setActiveIndices] = React.useState([0]);
    const { reload } = React.useContext(ObjectContext);

    return (
        <Box height={{ min: '100%' }}>
            <Accordion activeIndex={activeIndices} onActive={setActiveIndices}>
                <AccordionPanel
                    label={(
                        <FormattedMessage id="pipe-content-cables" defaultMessage="Cables" />
                    )}
                >
                    <StyledBox>
                        <Text size="12px">
                            <CableList
                                padLevel={1}
                                cables={cables}
                                editor={editor}
                                clicked={clicked}
                                setClicked={setClicked}
                                map={map}
                            />
                        </Text>
                    </StyledBox>
                </AccordionPanel>
                <AccordionPanel
                    label={(
                        <FormattedMessage id="permit-documents" defaultMessage="Documents" />
                    )}
                >
                    {!isEmpty(permitDocuments) ? (
                        <PermitDocumentList documents={permitDocuments} reload={reload} />
                    ) : (
                        <ContentRow padLevel={1}>
                            <ValueText>
                                <FormattedMessage id="no-permit-documents" defaultMessage="No permit documents" />
                            </ValueText>
                        </ContentRow>
                    )}
                </AccordionPanel>
            </Accordion>
        </Box>
    );
};

export default PipeContent;
